import styled from 'styled-components';

export const FormWrapper = styled.section`

    padding: 3rem 0;
    background-color: ${ props => props.theme.greyColor };

    @media (max-width: 1024px){
        padding: 3rem 1.5rem;
    }

    .container {

        h2 {
            font-size: 1.5rem;
            margin-bottom: 1rem;
        }

        p {
            color: ${ props => props.theme.secondaryColor };
            margin-bottom: 1rem;
        }

        .success {

            padding: 1rem;
            width: 100%;
            text-align: center;
            background-color: #228B22;
            color: ${ props => props.theme.lightColor };

        }

        .fail {

            padding: 1rem;
            width: 100%;
            text-align: center;
            background-color: #ff2727;
            color: ${ props => props.theme.lightColor };
        }

        form {

            .form-block {

                width: 100%;
                margin-bottom: 1rem; 

                input, textarea {
                    width: 100%;
                    padding: 1rem;
                    border: none;
                    outline: none;
                    height: 3rem;
                }

                textarea {

                    height: 8rem;

                }

            }

        }

    }

`